import type { Slug } from '@bridebook/toolbox/src/types';

/**
 * The categories a single-gender wedding does not need.
 *
 * Its own module because `supplier-categories.ts` imports the category icons,
 * and this constant is read by budget maths that runs server-side — where a
 * React component in the import graph is a build error, not dead weight.
 */
export const excludedSupplierCategories: Record<'groomOnly' | 'brideOnly', Slug[]> = {
  groomOnly: ['dress'],
  brideOnly: ['menswear'],
};
